/** @format */

import { ComponentFactory, ComponentFactoryResolver, NgModule } from '@angular/core';
import { HmfActionTextComponent, HmfButtonComponent } from '@dsg-tech/homefield-angular';
import {
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconAlertInfoFilled
} from '@dsg-tech/homefield-angular-icons';

import { CommonModule } from '@angular/common';
import { HomefieldButtonModule } from '@homefield';
import { MediaModule } from '@shared/media/components';
import { ProductInStoreServicesComponent } from './in-store-services.component';
import { SideNavModule } from '@shared/components';

@NgModule({
	declarations: [ProductInStoreServicesComponent],
	imports: [
		CommonModule,
		HmfActionTextComponent,
		HmfButtonComponent,
		HomefieldButtonModule,
		HomefieldIconLibraryModule,
		MediaModule,
		SideNavModule
	],
	exports: [ProductInStoreServicesComponent]
})
export class ProductInStoreServicesModule {
	constructor(
		private resolver: ComponentFactoryResolver,
		homefieldIconsLibraryService: HomefieldIconsLibraryService
	) {
		homefieldIconsLibraryService.registerIcons([homefieldIconAlertInfoFilled]);
	}

	public resolveComponentFactory(): ComponentFactory<ProductInStoreServicesComponent> {
		return this.resolver.resolveComponentFactory(ProductInStoreServicesComponent);
	}
}
